import { lazy } from "react";
import { FeatureFlagRoute } from "../../_features/featureFlags/routing/FeatureFlagRoute";
import PermissionRoute from "./PermissionRoute";
import { ROUTE_PERMISSIONS } from "./routePermissions";

const UpsellDownsellPage = lazy(() => import("../../_features/upsellDownsell/pages/UpsellDownsellPage"));
const UpsellCreatePage = lazy(() => import("../../_features/upsellDownsell/pages/UpsellCreatePage"));
const UpsellEditPage = lazy(() => import("../../_features/upsellDownsell/pages/UpsellEditPage"));
const UpsellPreviewPage = lazy(() => import("../../_features/upsellDownsell/pages/UpsellPreviewPage"));

export const upsellRoutes = [
    {
        path: "/upsellanddownsell", element:
            <FeatureFlagRoute feature="upsellsDownsells">
                <PermissionRoute permission={ROUTE_PERMISSIONS.upsellDownsell.view} moduleName="Upsell & downsell"><UpsellDownsellPage /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/upsellanddownsell/create", element:
            <FeatureFlagRoute feature="upsellsDownsells">
                <PermissionRoute permission={ROUTE_PERMISSIONS.upsellDownsell.create} moduleName="Upsell & downsell"><UpsellCreatePage /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/upsellanddownsell/:id/edit", element:
            <FeatureFlagRoute feature="upsellsDownsells">
                <PermissionRoute permission={ROUTE_PERMISSIONS.upsellDownsell.edit} moduleName="Upsell & downsell"><UpsellEditPage /></PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/upsellanddownsell/:id/preview", element:
            <FeatureFlagRoute feature="upsellsDownsells">
                <PermissionRoute permission={ROUTE_PERMISSIONS.upsellDownsell.view} moduleName="Upsell & downsell"><UpsellPreviewPage /></PermissionRoute>
            </FeatureFlagRoute>
    }
];
